<template>
  <b-badge
    :variant="BookingColorGenerator(state)"
    class="trip-details-status-badge"
  >
    <span>{{ snakeCaseToCamelCase(state) }}</span>
  </b-badge>
</template>

<script>
import { BBadge } from 'bootstrap-vue'
import snakeCaseToCamelCase from '@/utils/snake-case-to-camcel-caase'
import BookingColorGenerator from '../../hooks/bookingUtils'

export default {
  components: {
    BBadge,
  },
  props: {
    state: {
      type: String,
      default: '',
    },
  },
  setup() {
    return {
      BookingColorGenerator,
      snakeCaseToCamelCase,
    }
  },
}
</script>

  <style scoped>

  .trip-details-status-badge {
      padding:8px;
      border-radius: 15px;
  }
  </style>
